"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const prismjs_1 = __importDefault(require("prismjs"));
require("prismjs/components/prism-json");
require("prismjs/components/prism-python");
require("prismjs/themes/prism-twilight.css");
const json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
const isObject_1 = __importDefault(require("lodash/isObject"));
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const Code = (props) => {
    const { style = {}, sx = {}, testselector = "code-block", sort = false, language = "json", children } = props;
    const output = (0, react_1.useMemo)(() => {
        let result = "";
        if (sort) {
            if (typeof children === "string") {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unnecessary-type-assertion
                result = (0, json_stable_stringify_1.default)(JSON.parse(children), { space: " " });
            }
            else if ((0, isObject_1.default)(children)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unnecessary-type-assertion
                result = (0, json_stable_stringify_1.default)(children, { space: " " });
            }
        }
        else {
            if (typeof children === "string") {
                result = children;
            }
            else if ((0, isObject_1.default)(children)) {
                result = JSON.stringify(children, null, " ");
            }
        }
        return result;
    }, [sort, children]);
    const createMarkup = () => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        return { __html: prismjs_1.default.highlight(output, prismjs_1.default.languages[language], language) };
    };
    return (react_1.default.createElement(material_1.Box, { "data-testid": "code", sx: {
            width: "100%",
            overflow: "auto",
            pb: 2,
            pre: {
                overflow: "unset !important",
                background: "transparent !important",
            },
            ...sx,
        } },
        react_1.default.createElement("pre", { style: {
                border: "none",
                borderRadius: 0,
                boxShadow: "none",
                backgroundColor: colors_1.default.secondary[900],
                margin: 0,
                padding: 0,
                lineHeight: 1.2,
                ...style,
            }, "data-cy": testselector, dangerouslySetInnerHTML: createMarkup() })));
};
exports.default = Code;
